/* "Duo buy 1 get 1 free" block: 2 bracelets added together (items[0], items[1]) with colour, names and preview. */
(function () {
  if (customElements.get('smr-duo')) return;

  function radios(fid, pos) {
    return [].filter.call(document.querySelectorAll('input[type="radio"]'), function (r) {
      return r.name.indexOf(fid) === 0 && new RegExp('option' + pos + '$').test(r.name);
    });
  }

  class SmrDuo extends HTMLElement {
    connectedCallback() {
      if (this._on) return;
      this._on = true;
      this.fid = this.dataset.form;
      var self = this;
      this.querySelectorAll('.smd-pill').forEach(function (p) {
        p.addEventListener('click', function () { self.pick(p); });
      });
      this.querySelectorAll('input[data-name]').forEach(function (i) {
        i.addEventListener('input', function () {
          var c = i.parentNode.querySelector('.smd-cnt');
          if (c) c.textContent = i.value.length + '/' + i.maxLength;
          if (i.value.trim()) { var card = i.closest('.smd-card'); if (card) card.classList.remove('has-err'); }
          self.sync();
        });
      });
      this._submit = function (e) { self.submit(e); };
      document.addEventListener('submit', this._submit, true);
      this.sync();
    }
    disconnectedCallback() {
      this._on = false;
      document.removeEventListener('submit', this._submit, true);
    }
    pick(p) {
      if (p.disabled) return;
      var box = p.closest('.smd-pills');
      box.querySelectorAll('.smd-pill').forEach(function (x) { var on = x === p; x.classList.toggle('on', on); x.setAttribute('aria-checked', on ? 'true' : 'false'); });
      // Bracelet 1 drives the displayed variant (gallery photo).
      if (p.closest('.smd-b').dataset.b === '1') {
        var r = radios(this.fid, 1)[+p.dataset.pos - 1];
        if (r && !r.checked) { r.click(); if (!r.checked) { r.checked = true; r.dispatchEvent(new Event('change', { bubbles: true })); } }
      }
      this.sync();
    }
    chosen(b) {
      return this.querySelector('.smd-b[data-b="' + b + '"] .smd-pill.on') || this.querySelector('.smd-b[data-b="' + b + '"] .smd-pill:not([disabled])');
    }
    names() {
      return [].map.call(this.querySelectorAll('input[data-name]'), function (i) { return i.value.trim(); });
    }
    sync() {
      var d = this.dataset, n = this.names(), box = this.querySelector('.smd-items'), fid = this.fid, html = [];
      var esc = function (s) { return String(s).replace(/&/g, '&amp;').replace(/"/g, '&quot;').replace(/</g, '&lt;'); };
      [1, 2].forEach(function (b, j) {
        var p = this.chosen(b);
        if (!p) return;
        var base = 'items[' + j + ']';
        html.push('<input type="hidden" form="' + fid + '" name="' + base + '[id]" value="' + p.dataset.v + '">');
        html.push('<input type="hidden" form="' + fid + '" name="' + base + '[quantity]" value="1">');
        if (d.pb) html.push('<input type="hidden" form="' + fid + '" name="' + base + '[properties][' + esc(d.pb) + ']" value="' + esc(b === 1 ? d.b1 : d.b2) + '">');
        if (n.length) {
          html.push('<input type="hidden" form="' + fid + '" name="' + base + '[properties][' + esc(d.p1) + ']" value="' + esc(n[0]) + '">');
          html.push('<input type="hidden" form="' + fid + '" name="' + base + '[properties][' + esc(d.p2) + ']" value="' + esc(n[1]) + '">');
        }
      }, this);
      box.innerHTML = html.join('');
      this.preview(n);
    }
    preview(n) {
      var pv = this.querySelector('.smd-prev');
      if (!pv) return;
      var p = this.chosen(1), base = pv.querySelector('.smd-base');
      var src = pv.dataset.base.replace('[metal]', p ? p.dataset.k : 'or');
      if (base.getAttribute('src') !== src) base.src = src;
      var e1 = pv.querySelector('.smd-n1'), e2 = pv.querySelector('.smd-n2');
      // Long names shrink to stay on the plate.
      [[e1, n[0]], [e2, n[1]]].forEach(function (x) {
        if (!x[0]) return;
        if (x[1]) x[0].textContent = x[1];
        x[0].style.setProperty('--k', Math.min(1, 7 / Math.max(1, x[0].textContent.length)));
      });
    }
    submit(e) {
      var f = e.target;
      if (!f || f.getAttribute('id') !== this.fid) return;
      this.sync();
      var ins = this.querySelectorAll('input[data-name]'), miss = [].filter.call(ins, function (i) { return !i.value.trim(); });
      if (miss.length) {
        e.preventDefault();
        e.stopImmediatePropagation();
        var card = miss[0].closest('.smd-card');
        card.classList.add('has-err');
        card.scrollIntoView({ behavior: 'smooth', block: 'center' });
        miss[0].focus({ preventScroll: true });
        return;
      }
      // Both bracelets go in items[0] and items[1]: disable the form's "id" (and quantity) fields while submitting.
      var off = [].filter.call(f.elements, function (x) { return (x.name === 'id' || x.name === 'quantity') && !x.disabled; });
      off.forEach(function (x) { x.disabled = true; });
      setTimeout(function () { off.forEach(function (x) { x.disabled = false; }); }, 0);
    }
  }
  customElements.define('smr-duo', SmrDuo);
})();
